module.exports = __webpack_public_path__ + "static/img/3768_phase_function_Paper_Points.5bc5c6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3768_phase_function_Paper_Points.png
// module id = YZBS
// module chunks = 0